define([
    'text!product-detail/gallery/brand-info.html',
    'product-detail/mixin/product',

    'css!product-detail/gallery/brand-info.css'
], function(
    tpl,
    ProductMixin
){
    return {
        template: tpl,
        mixins: [ProductMixin],
        computed: {
            brandInfo: function(){
                return this.spu.brandInfo || {};
            },
            brandImage: function(){
                return this.brandInfo.brandLogo || this.brandInfo.brandImg || '';
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/gallery/brand-info.js
// module id = 334
// module chunks = 0